var country = $(".checkout-form").data("language");

$(".delivery .options-wrapper").on("click", function (e) {
    $(".delivery .options-wrapper").removeClass("active");
    $(this).addClass("active");

    var shipping_to = $(".delivery .options-wrapper .option:checked").val();
    if (shipping_to == 1) {
        $(".office-info").slideUp("fast");
        $(".address-info").slideDown("fast");
    } else {
        $(".office-info").slideDown("fast");
        $(".address-info").slideUp("fast");
    }
});

$(".payment .options-wrapper").on("click", function (e) {
    $(".payment .options-wrapper").removeClass("active");
    $(this).addClass("active");

    var payment = $(".payment .options-wrapper .option:checked").val();

    if (payment == 1) {
        $(".pay-with-card").slideUp("fast");
        $(".pay-on-delivery").slideDown("fast");
    } else {
        $(".pay-with-card").slideDown("fast");
        $(".pay-on-delivery").slideUp("fast");
    }
});

$(".invoice_check").on("change", function (e) {
    var invoice = $(".invoice_check:checked").val();
    if (invoice == 1) {
        $(".invoice-wrapper").slideDown("fast");
    } else {
        $(".invoice-wrapper").slideUp("fast");
    }
});

// $("#city").autocomplete({
//   source: "/"+country+"/get-cities",
//   focus: function() {
//     return false;
//   },
//   select: function (event, suggestion) {
//     var name = suggestion.item.value;
//     var value_input = suggestion.item.city;
//     var city_id = suggestion.item.city_id;
//     var zip = suggestion.item.zip;

//     setTimeout(function(){
//       $('#city').val(value_input);
//       $('#city_id').val(city_id);
//       $('#zip').val(zip);
//       $("#address").autocomplete('option', 'source', "/"+country+'/'+city_id+"/get-addresses");
//       $("#office").autocomplete('option', 'source', "/"+country+'/'+city_id+"/get-offices");
//     },150);

//   }
// });

// $("#address").autocomplete({
//   source: "/"+country+'/'+$('#city_id').val()+"/get-addresses",
//   focus: function() {
//     // prevent value inserted on focus
//     return false;
//   },
//   select: function (event, suggestion) {
//     var name = suggestion.item.label;
//     var address_id = suggestion.item.id;

//     $('#address_id').val(address_id);
//   }
// });

// $("#office").autocomplete({
//   source: "/"+country+'/'+$('#city_id').val()+"/get-offices",
//   focus: function() {
//     // prevent value inserted on focus
//     return false;
//   },
//   minLength: 0,
//   select: function (event, suggestion) {
//     var name = suggestion.item.label;
//     var office_id = suggestion.item.id;

//     $('#office_id').val(office_id);
//   }
// });
// $("#office").on('click', function(){
//   $(this).autocomplete("search", $(this).val());
// })

$(document).on("click", ".open-addresses-modal", function () {
    var url = $(this).attr("data-modal-href"); // Use $(this) to get the correct element

    $("#courier-modal")
        .find(".modal-content")
        .load(url, function () {
            // Livewire 2 initialization for addresses modal
            window.livewire.rescan();

            const wrapper = document.getElementById("address-wrapper");
            if (wrapper) {
                wrapper.addEventListener("scroll", () => {
                    // Разстояние от дъното до текущата позиция
                    const scrollBottom =
                        wrapper.scrollHeight -
                        wrapper.scrollTop -
                        wrapper.clientHeight;

                    // Ако сме на по-малко от 50px от дъното, зареждаме повече
                    if (scrollBottom < 50) {
                        // Livewire 2 event emission for addresses
                        window.livewire.emit("loadMoreAddresses");
                    }
                });
            }
        });
});

$(document).on("click", ".open-courier-modal", function () {
    var modalUrl = $(this).attr("data-modal-href");

    $("#courier-modal")
        .find(".modal-content")
        .load(modalUrl, function () {
            // Livewire 2 initialization
            window.livewire.rescan();

            const wrapper = document.getElementById("cities-wrapper");
            if (wrapper) {
                wrapper.addEventListener("scroll", () => {
                    // Разстояние от дъното до текущата позиция
                    const scrollBottom =
                        wrapper.scrollHeight -
                        wrapper.scrollTop -
                        wrapper.clientHeight;

                    // Ако сме на по-малко от 50px от дъното, зареждаме повече
                    if (scrollBottom < 50) {
                        // Livewire 2 event emission
                        window.livewire.emit("loadMore");
                    }
                });
            }
        });
});

$(document).on("click", ".open-quarter-modal", function () {
    var url = $(".open-quarter-modal").attr("data-modal-href"); // Use $(this) to get the correct element
    $("#courier-modal")
        .find(".modal-content")
        .load(url, function () {
            Livewire.rescan();
        });
});

$(document).on("click", ".open-office-modal", function () {
    var url = $(".open-office-modal").attr("data-modal-href"); // Use $(this) to get the correct element
    $("#courier-modal")
        .find(".modal-content")
        .load(url, function () {
            Livewire.rescan();
        });
});
